export const METHODS_OTPS = {
  WHATSAPP: 'whatsapp',
  SMS: 'sms'
}
